module.exports = __webpack_public_path__ + "static/media/trophy.d5891e49.svg";